import React, { useState } from "react";
import UserAccountDetails from "./UserAccountDetails";
import ChangePasswordLink from "../../features/users/components/ChangePasswordLink";
import "../Settings/ChangePassword.css";
import "../Settings/SettingsPage.css";

export default function UserSettingsPage() {
  const [activeTab, setActiveTab] = useState("AccountDetails");

  return (
    <div className="settings-page">
      {/* Main Content */}
      <div className="main-content">
        {/* Sidebar */}
        <div className="settings-sidebar">
          <ul>
            <li
              className={`settings-sidebar-item ${
                activeTab === "AccountDetails" ? "active" : ""
              }`}
              onClick={() => setActiveTab("AccountDetails")}
            >
              Account Details
            </li>
            
          </ul>
        </div>

        {/* Content Area */}
        <div className="settings-container">
          {activeTab === "AccountDetails" && <UserAccountDetails />}
          {activeTab === "AccountDetails" && <ChangePasswordLink />}
        </div>
      </div>
    </div>
  );
}
